module.exports = __webpack_public_path__ + "img/logo_b.fc1dfd04.png";